import { render } from "./AddMlopsView.vue?vue&type=template&id=b95a2794&scoped=true"
import script from "./AddMlopsView.vue?vue&type=script&lang=js"
export * from "./AddMlopsView.vue?vue&type=script&lang=js"

import "./AddMlopsView.vue?vue&type=style&index=0&id=b95a2794&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95a2794"]])

export default __exports__